<template>
  <div class="hotLab">
    <div class="hotLab-top">热门实验室</div>
    <div class="hotLab-num">
      已入驻<span>{{ labTotal }}</span
      >家实验室
    </div>
    <div class="list" v-loading="listLoading">
      <div
        v-for="(item, index) in lists"
        :key="index"
        class="flex flex-row list-item flex-top"
      >
        <div
          class="list-num flex flex-center flex-middle"
          :class="{ [`index${index + 1}`]: true }"
        >
          {{ index + 1 }}
        </div>
        <div class="list-con flex-1">
          <div class="list-labName pointer" @click="toLabDetail(item)">
            {{ item.laboratoryName }}
          </div>
          <div class="flex flex-row flex-between list-other">
            <div>设备 {{ item.waresSum }}</div>
            <div>能力 {{ item.abilitySum }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { recommendLabList, labTotalNum } from "@/api/lab";
export default {
  data() {
    return {
      lists: [],
      labTotal: 0,
      listLoading: false,
      page: {
        pageIndex: 1,
        pageSize: 10,
      },
    };
  },
  created() {
    this.getList();
    this.getLabTotal();
  },
  methods: {
    async getList() {
      this.listLoading = true;
      const res = await this.$axios
        .post(recommendLabList, this.page)
        .finally(() => {
          this.listLoading = false;
        });
      this.lists = res;
    },
    async getLabTotal() {
      const res = await this.$axios.post(labTotalNum, {
        laboratoryStatus: "1",
      });
      this.labTotal = res;
    },
    toLabDetail({ laboratoryId }) {
      this.$jump.push({ name: "labDetail", query: { id: laboratoryId } });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.hotLab {
  background: white;
  width: 100%;
  &-top {
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: white;
    font-size: 16px;
    background: url($oss-url + "home/title-bg/title-bg-1.png") no-repeat center
      center / cover;
  }
  &-num {
    text-align: left;
    font-size: 14px;
    padding: 20px 15px;
    color: #999;
    span {
      color: #333;
      margin: 0 2px;
    }
  }
}
.list {
  padding-right: 15px;
  padding-bottom: 10px;
  &-item {
    margin-bottom: 10px;
  }
  &-num {
    width: 24px;
    height: 24px;
    border-radius: 12px;
    background: #005ca7;
    color: #fff;
    margin: 0 15px;
    font-size: 14px;
    font-weight: bolder;
  }
  &-labName {
    font-size: 14px;
    color: #1c1c1c;
    margin-bottom: 8px;
  }
  &-other {
    font-size: 12px;
    color: #666666;
    padding-bottom: 8px;
    border-bottom: 1px dashed #d1d1d1;
  }
}
.list-item:last-child {
  margin-bottom: 0;
  .list-other {
    border-bottom: none;
  }
}
</style>
